import Vue from 'vue'
import { clone } from '@/js/utils'
import data_unlocks from '@/data/data_unlocks'


// === STATE =====================================================================================
const default_state = {
	diamonds: 0,
	viewed_unlocks: [],
	viewed_tutos: [],
	settings: {
		lang: 'en',
		quality: 'high',
		sounds: 5
	},
}
const state = clone(default_state)






// === GETTERS =====================================================================================
const getters = {
	user(state) { return state },
	lang(state) { return state.settings.lang },
}







// === ACTIONS =====================================================================================
const actions = {

	check_unlocks({ dispatch }) {
		const unlock = data_unlocks.find(u => u.diamonds && state.diamonds >= u.diamonds && !state.viewed_unlocks.find(v => v.type === u.type && v.slug === u.slug))
		if (unlock) {
			dispatch('add_popup', { type: 'unlock', unlock })
		}
	},

	add_viewed_unlock({ state, commit }, data) {
		if (data.unlock) {
			const exists = state.viewed_unlocks.find(u => u.type === data.unlock.type && u.slug === data.unlock.slug)
			if (!exists) commit('EDIT_USER_STATE', { viewed_unlocks: [ ...state.viewed_unlocks, data.unlock ] })
		}
	},

	async save_user({ state }) {
		try {
			localStorage.setItem('zany-user', JSON.stringify(state))
			console.info('[ USER SAVED ]')
		} catch (error) {
			console.error(error)
		}
	},

	async save_game({ rootGetters }) {
		try {
			localStorage.setItem('zany-game', JSON.stringify({ game: rootGetters.game }))
		} catch (error) {
			console.error(error)
		}
	},

	async unsave_game() {
		try {
			localStorage.removeItem('zany-game')
			console.log('GAME REMOVED')
		} catch (error) {
			console.error(error)
		}
	},

	async load_user({ commit }) {

		// Load user data
		try {
			const data = JSON.parse(localStorage.getItem('zany-user'))
			if (data) commit('EDIT_USER_STATE', { ...default_state, ...data })
		} catch (error) {
			console.error('Unable to load user', error)
		}
		
		// Load game
		try {
			const data = JSON.parse(localStorage.getItem('zany-game'))
			if (data) {
				if (data.game) commit('EDIT_GAME_STATE', data.game)
			}
		} catch (error) {
			console.error('Unable to load game', error)
		}
	},


	async reset_user_progression() {
		localStorage.removeItem('zany-game')
		localStorage.removeItem('zany-user')
		location.reload()
	}
	
}



// === MUTATIONS =====================================================================================
const mutations = {

	EDIT_USER_STATE(state, data) {
		for (var i in data) {
			Vue.set(state, i, data[i])
		}
	},

}

export default { state, getters, actions, mutations }
